import { DarkTheme } from "./dark-theme";
import { LightTheme } from "./light-theme";


const customizeTheme = {
    DarkTheme,
    LightTheme
};

export default customizeTheme;